"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.componentBackend = exports.component = void 0;
const createApi_1 = require("../../helpers/createApi");
const post = (caller) => ({ accountId, componentParams }) => {
    const url = `/accounts/${accountId}/components`;
    return caller(url).post({ ...componentParams }, { withResponse: true });
};
const patch = (caller) => ({ accountId, componentId, componentParams }) => {
    const url = `/accounts/${accountId}/components/${componentId}`;
    return caller(url).patch({ ...componentParams });
};
const get = (caller) => ({ accountId, componentId }) => {
    const url = `/accounts/${accountId}/components/${componentId}`;
    return caller(url).get();
};
const remove = (caller) => ({ accountId, componentId }) => {
    const url = `/accounts/${accountId}/components/${componentId}`;
    return caller(url).delete();
};
const list = (caller) => ({ accountId, all }) => {
    const url = `/accounts/${accountId}/components`;
    return all ? caller(url).get() : caller(url).get({ account_ids: [accountId] });
};
const datas = (caller) => ({ accountId, all }) => {
    const url = `/accounts/${accountId}/components`;
    return all ? caller(url).get() : caller(url).get({ account_ids: [accountId] });
};
const multipleDuplicate = (caller) => ({ accountId, ...payload }) => {
    const url = `/accounts/${accountId}/components`;
    return caller(url).post({ ...payload }, { withResponse: true });
};
exports.component = (0, createApi_1.createAPIFactory)({
    create: post,
    patch,
    get,
    delete: remove,
    list,
    datas,
    multipleDuplicate,
});
const put = (caller) => (params) => {
    const url = `backend/asset`;
    return caller(url).put({ ...params }, { withResponse: true });
};
exports.componentBackend = (0, createApi_1.createAPIFactory)({
    put,
});
//# sourceMappingURL=api.js.map